// APP FRONTEND
export const APP_DOMAIN = '';
export const APP_SUBPATH = '';

// FIREBASE

export const GOOGLE_GEOCODE_API_KEY = 'AIzaSyBOWNQ0VD1AvJuYZwvQUdohHhJA_DCEIEo';
export const STRIPE_PUBLIC_KEY = 'pk_live_pM9jTbpyzwLSJJ4VXh1ZKz5900Ig5Uwh9L';

